import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {Link} from "react-router-dom";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {useHistory} from "react-router-dom";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {updateDocumentTitle} from "../../Utils/Common";
import {isEmpty} from "lodash";
import styled from "styled-components";
import PageLayout from "../Layout/PageLayout";
import {Button, Card, CardTitleBar, CardBody, FormField, Select, Spinner, StatusBadge, Tabs} from "../UI";
import {tokens, mq} from "../../theme/tokens";
import {ReasonCaptureModal} from "../Common/ReasonCaptureModal";

const Columns = styled.div`
    display: grid;
    gap: ${tokens.spacing[5]};
    grid-template-columns: 1fr;
    ${mq.lg} { grid-template-columns: 1fr 1fr; }
`;

const KV = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: ${tokens.typography.size.base};
    margin-bottom: ${tokens.spacing[5]};

    td {
        padding: ${tokens.spacing[2]} ${tokens.spacing[3]};
        border-bottom: 1px solid ${tokens.colors.divider};
        vertical-align: top;
    }
    td:first-child { color: ${tokens.colors.muted}; white-space: nowrap; }
    td:last-child {
        color: ${tokens.colors.heading};
        font-weight: ${tokens.typography.weight.semibold};
    }
    a { color: ${tokens.colors.primary}; }
    tr:last-child td { border-bottom: 0; }
`;

const Grid = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: ${tokens.typography.size.base};

    th {
        text-align: left;
        padding: ${tokens.spacing[2]} ${tokens.spacing[3]};
        font-size: ${tokens.typography.size.xs};
        font-weight: ${tokens.typography.weight.bold};
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: ${tokens.colors.muted};
        background: ${tokens.colors.cream};
        border-bottom: 1px solid ${tokens.colors.border};
    }
    td {
        padding: ${tokens.spacing[3]};
        border-bottom: 1px solid ${tokens.colors.divider};
        color: ${tokens.colors.body};
        vertical-align: top;
    }
    a { color: ${tokens.colors.primary}; }
    tr:last-child td { border-bottom: 0; }
`;

const TableCard = styled(Card)`
    overflow-x: auto;
    margin-bottom: ${tokens.spacing[5]};
`;

const FormCard = styled(Card)`
    margin-bottom: ${tokens.spacing[5]};
`;

const TimelineItem = styled.div`
    display: flex;
    align-items: flex-start;
    gap: ${tokens.spacing[4]};
    padding: ${tokens.spacing[4]} 0;
    border-bottom: 1px solid ${tokens.colors.divider};

    &:last-child { border-bottom: 0; }

    .icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        border-radius: ${tokens.radii.circle};
        background: ${tokens.colors.rose};
        color: ${tokens.colors.primary};
        flex-shrink: 0;
    }
    .text {
        margin: 0;
        color: ${tokens.colors.heading};
        font-size: ${tokens.typography.size.md};
        font-style: italic;
    }
    .time {
        margin: 4px 0 0;
        font-size: ${tokens.typography.size.sm};
        color: ${tokens.colors.muted};
    }
`;

const RequestDetails = props => {
    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({title: ''});
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [tab, setTab] = useState("details");

    const [deliveryType, setDeliveryType] = useState('');
    const [requestTypeList, setRequestTypeList] = useState([]);

    const [regionList, setRegionList] = useState([]);
    const [pickUpRegion, setPickUpRegion] = useState('');
    const [dropOffRegion, setDropOffRegion] = useState('');

    const [riderList, setRiderList] = useState([]);
    const [riderId, setRiderId] = useState('');
    const [riderRole, setRiderRole] = useState('rider_one');


    const {id} = props.match.params;

    const load = (loadExtras = false) => {
        let data = new FormData();
        data.append("id", id);

        setIsLoading(true);
        postData(Endpoints.REQUEST_DETAIL, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setItem(res.data);
                    updateDocumentTitle(res.data.request_code)
                    setDeliveryType(res.data.delivery_type);
                    setPickUpRegion(res.data.region_pick_up);
                    setDropOffRegion(res.data.region_drop_id);
                    setRiderId(res.data.rider_id);
                    if (loadExtras) {
                        loadRequestTypes(res.data.area_id)
                        loadRegions(res.data.area_id)
                        loadRiders(res.data.rider_id)
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    useEffect(() => {
        load(true)
    }, []);

    function loadRequestTypes(areaId) {
        let data = new FormData();
        data.append("area_id", areaId);
        setIsLoading(true)
        postData(Endpoints.REQUEST_TYPE_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setRequestTypeList(res.data || []);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function loadRegions(areaId) {
        let data = new FormData();
        data.append("area_id", areaId);
        data.append("status", 1);
        setIsLoading(true)
        postData(Endpoints.REGION_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setRegionList(res.data || []);
                    if (res.data.length > 0) {
                        setPickUpRegion(res.data[0].id);
                        setDropOffRegion(res.data[0].id);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    const loadRiders = (selectedRider) => {
        let data = new FormData();
        data.append("status", 1);
        setIsLoading(true);
        postData(Endpoints.RIDER_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setRiderList(res.data || []);
                    if (res.data.length > 0 && isEmpty(selectedRider)) {
                        setRiderId(res.data[0].id);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    const updateDeliveryType = e => {
        e.preventDefault();

        let data = new FormData();
        data.append("delivery_type", deliveryType)
        data.append("id", item.id)

        setIsLoading(true);

        postData(Endpoints.REQUEST_UPDATE_DELIVERY, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    Notify(res.data, SUCCESS);
                    load()
                } else {
                    if (Array.isArray(res.data)) {
                        Notify(res.data[0], ERROR);
                    } else {
                        Notify(res.message, ERROR);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    const assignRegion = e => {
        e.preventDefault();

        let data = new FormData();
        data.append("region_drop", dropOffRegion)
        data.append("region_pick_up", pickUpRegion)
        data.append("id", item.id)

        setIsLoading(true);

        postData(Endpoints.REQUEST_ASSIGN_REGION, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    Notify(res.data, SUCCESS);
                    load()
                } else {
                    if (Array.isArray(res.data)) {
                        Notify(res.data[0], ERROR);
                    } else {
                        Notify(res.message, ERROR);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    const assignRider = e => {
        e.preventDefault();

        let data = new FormData();
        data.append("role", riderRole)
        data.append("rider_id", riderId)
        data.append("id", item.id)

        setIsLoading(true);

        postData(Endpoints.REQUEST_ASSIGN_RIDER, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    Notify(res.data, SUCCESS);
                    load()
                } else {
                    if (Array.isArray(res.data)) {
                        Notify(res.data[0], ERROR);
                    } else {
                        Notify(res.message, ERROR);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    const cancelRequest = reason => {
        let data = new FormData();
        data.append("reason", reason)
        data.append("id", item.id)

        setIsLoading(true);

        postData(Endpoints.REQUEST_CANCEL, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    Notify(res.data, SUCCESS);
                    load()
                } else {
                    if (Array.isArray(res.data)) {
                        Notify(res.data[0], ERROR);
                    } else {
                        Notify(res.message, ERROR);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    return (
        <PageLayout
            title={item.request_code ? `#${item.request_code}` : ''}
            actions={item.title !== '' &&
            <>
                {isLoading && <Spinner size={20}/>}
                {item.status && <StatusBadge status={item.status}/>}
                <Link to={`/request/${id}/chain`}>
                    <Button variant="outline">View chain of custody</Button>
                </Link>
                <Link to="/requests">
                    <Button variant="secondary">Back to requests</Button>
                </Link>
            </>
            }
        >
            {item.title !== '' &&
            <>
                <Tabs
                    tabs={[
                        {key: "details", label: "Overview"},
                        {key: "sender", label: "Sender / From"},
                        {key: "dropoffs", label: "Drop offs"},
                        {key: "riders", label: "Riders"},
                        {key: "tracking", label: "Tracking"},
                    ]}
                    value={tab}
                    onChange={setTab}
                />

                {tab === "details" &&
                <Columns>
                    <div>
                        <Card>
                            <KV>
                                <tbody>
                                <tr>
                                    <td>Area</td>
                                    <td>{item.area.title}</td>
                                </tr>
                                <tr>
                                    <td>Pick up location</td>
                                    <td>{item.pick_up_location}</td>
                                </tr>
                                <tr>
                                    <td>Delivery Type</td>
                                    <td>{item.delivery_type}</td>
                                </tr>
                                <tr>
                                    <td>Means</td>
                                    <td>{item.means}</td>
                                </tr>
                                <tr>
                                    <td>Pick Up Type</td>
                                    <td>{item.pick_up_type}</td>
                                </tr>
                                {item.is_scheduled === 1 &&
                                <tr>
                                    <td>Pick Up Time</td>
                                    <td>{item.pick_up_date_time_string}</td>
                                </tr>
                                }
                                <tr>
                                    <td>Expected Completion Time</td>
                                    <td>{item.expected_end_time_string}</td>
                                </tr>
                                <tr>
                                    <td>Request Status</td>
                                    <td>{item.status}</td>
                                </tr>

                                <tr>
                                    <td>Assigned R1 rider</td>
                                    <td>{item.rider_details.name}</td>
                                </tr>

                                {item.status === "CANCELLED" &&
                                <tr>
                                    <td>Cancellation Reason</td>
                                    <td>{item.cancellation_reason}</td>
                                </tr>
                                }

                                <tr>
                                    <td>Progress Status</td>
                                    <td>{item.progress_status}</td>
                                </tr>
                                <tr>
                                    <td>Perf. Status</td>
                                    <td>{item.performance_status}</td>
                                </tr>
                                <tr>
                                    <td>Total Distance</td>
                                    <td>{item.distance_km} Km</td>
                                </tr>

                                {item.region_pick_up > 0 &&
                                <tr>
                                    <td>Pick Up Region</td>
                                    <td>{item.pick_up_region_details.title}</td>
                                </tr>
                                }

                                {item.region_drop_id > 0 &&
                                <tr>
                                    <td>Drop Off Region</td>
                                    <td>{item.drop_off_region_details.title}</td>
                                </tr>
                                }

                                <tr>
                                    <td>Fee</td>
                                    <td>KES {item.fee}</td>
                                </tr>
                                <tr>
                                    <td>Payment Status</td>
                                    <td>{item.payment_status}</td>
                                </tr>
                                <tr>
                                    <td>Payment Method</td>
                                    <td>{item.payment_method}</td>
                                </tr>
                                <tr>
                                    <td>Rave Payment Method</td>
                                    <td>{item.rave_payment_method}</td>
                                </tr>
                                <tr>
                                    <td>Transaction ID</td>
                                    <td>{item.transaction_id}</td>
                                </tr>
                                <tr>
                                    <td>Promo Code</td>
                                    <td>{item.promo_code}</td>
                                </tr>
                                <tr>
                                    <td>Discount Applied</td>
                                    <td>KES {item.promo_code_discount}</td>
                                </tr>
                                <tr>
                                    <td>Rider Two Code</td>
                                    <td>{item.code_rider_two}</td>
                                </tr>
                                <tr>
                                    <td>Call Centre Code</td>
                                    <td>{item.code_call_centre}</td>
                                </tr>
                                <tr>
                                    <td>Rider Three Code</td>
                                    <td>{item.code_rider_three}</td>
                                </tr>
                                <tr>
                                    <td>Rider Four Code</td>
                                    <td>{item.code_rider_four}</td>
                                </tr>
                                {item.source === 'api' &&
                                <tr>
                                    <td>Source</td>
                                    <td>
                                        <StatusBadge tone="info" size="sm">API</StatusBadge>
                                        {item.mode === 'test' &&
                                        <span style={{marginLeft: 8}}><StatusBadge tone="warn" size="sm">TEST</StatusBadge></span>}
                                    </td>
                                </tr>}
                                {item.source === 'api' && item.api_key_id &&
                                <tr>
                                    <td>API key</td>
                                    <td>{item.api_key_id}</td>
                                </tr>}
                                {item.source === 'api' && item.external_reference &&
                                <tr>
                                    <td>External reference</td>
                                    <td>{item.external_reference}</td>
                                </tr>}
                                <tr>
                                    <td>From Corporate</td>
                                    <td>{item.corporate_id > 0 ? "YES" : "NO"}</td>
                                </tr>
                                {item.corporate_id > 0 ?
                                    <div>
                                        <tr>
                                            <td>Business</td>
                                            <td>
                                                <Link
                                                    to={"/business/" + item.corporate_id}>{item.business_details.name}</Link>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Department</td>
                                            <td>
                                                <Link
                                                    to={"/department/" + item.department_id}>{item.department_details.name}</Link>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Billed to</td>
                                            <td>
                                                <Link
                                                    to={"/account/" + item.child_account_id}>{item.child_account_details.email}</Link>
                                            </td>
                                        </tr>
                                    </div>
                                    : <tr>
                                        <td>Billed to</td>
                                        <td>{item.user_details.email}</td>
                                    </tr>}


                                <tr>
                                    <td>Promo Code</td>
                                    <td>{item.promo_code}</td>
                                </tr>
                                <tr>
                                    <td>Promo Discount</td>
                                    <td>{item.promo_discount}</td>
                                </tr>
                                <tr>
                                    <td>Applied Referral Discount</td>
                                    <td>{item.applied_referral_discount === 1 ? "YES" : "NO"}</td>
                                </tr>
                                <tr>
                                    <td>Fines</td>
                                    <td>KES {item.fines}</td>
                                </tr>
                                <tr>
                                    <td>Night charges applied</td>
                                    <td>{item.night_charges_applied === 1 ? "YES" : "NO"}</td>
                                </tr>
                                </tbody>
                            </KV>

                            <KV style={{marginBottom: 0}}>
                                <tbody>
                                <tr>
                                    <td>Customer Feedback</td>
                                    <td>{item.customer_feedback}</td>
                                </tr>
                                <tr>
                                    <td>Customer Rating</td>
                                    <td>{item.customer_rating}</td>
                                </tr>
                                <tr>
                                    <td>Rider Review</td>
                                    <td>{item.rider_review}</td>
                                </tr>
                                </tbody>
                            </KV>
                        </Card>
                    </div>
                    <div>

                        {item.status !== "CANCELLED" &&
                        <div>
                            <FormCard padded={false}>
                                <CardTitleBar title="Assign rider"/>
                                <CardBody>
                                    <form onSubmit={assignRider}>
                                        <FormField label="Select role" htmlFor="assignRole">
                                            <Select
                                                id="assignRole"
                                                required={true}
                                                value={riderRole}
                                                onChange={e => {
                                                    setRiderRole(e.target.value)
                                                }}
                                            >
                                                <option value="rider_one">Rider One (R1)</option>
                                                <option value="rider_two">Rider Two (R2)</option>
                                                <option value="rider_three">Rider Three (R3)</option>
                                                <option value="rider_four">Rider Four (R4)</option>
                                            </Select>
                                        </FormField>

                                        <FormField label="Select rider" htmlFor="assignRiderSelect">
                                            <Select
                                                id="assignRiderSelect"
                                                required={true}
                                                value={riderId}
                                                onChange={e => {
                                                    setRiderId(e.target.value)
                                                }}
                                            >
                                                {riderList.map((i, k) => <option
                                                    key={k}
                                                    value={i.id}>{i.name} - {i.ongoing_jobs} ongoing
                                                    jobs</option>
                                                )}
                                            </Select>
                                        </FormField>

                                        <Button type="submit" loading={isLoading}>Assign</Button>
                                    </form>
                                </CardBody>
                            </FormCard>

                            <FormCard padded={false}>
                                <CardTitleBar title="Update region"/>
                                <CardBody>
                                    <form onSubmit={assignRegion}>
                                        <FormField label="Pick up region" htmlFor="pickUpRegionSelect">
                                            <Select
                                                id="pickUpRegionSelect"
                                                required={true}
                                                value={pickUpRegion}
                                                onChange={e => {
                                                    setPickUpRegion(e.target.value)
                                                }}
                                            >
                                                {regionList.map((i, k) => <option
                                                    key={k}
                                                    value={i.id}
                                                    selected={i.id === item.region_pick_up}>{i.title}</option>
                                                )}
                                            </Select>
                                        </FormField>

                                        <FormField label="Drop off region" htmlFor="dropOffRegionSelect">
                                            <Select
                                                id="dropOffRegionSelect"
                                                required={true}
                                                value={dropOffRegion}
                                                onChange={e => setDropOffRegion(e.target.value)}
                                            >
                                                {regionList.map((i, k) => <option
                                                    key={k}
                                                    value={i.id}
                                                    selected={i.id === item.region_drop_id}>{i.title}</option>
                                                )}
                                            </Select>
                                        </FormField>

                                        <Button type="submit" loading={isLoading}>Update</Button>
                                    </form>
                                </CardBody>
                            </FormCard>

                            <FormCard padded={false}>
                                <CardTitleBar title="Update delivery type"/>
                                <CardBody>
                                    <form onSubmit={updateDeliveryType}>
                                        <FormField label="Select delivery type" htmlFor="deliveryTypeSelect">
                                            <Select
                                                id="deliveryTypeSelect"
                                                required={true}
                                                placeholder="Name"
                                                value={deliveryType}
                                                onChange={e => setDeliveryType(e.target.value)}
                                            >
                                                {requestTypeList.map((i, k) => <option
                                                    key={k}
                                                    value={i.name}
                                                    selected={i.name === item.delivery_type}>{i.name}</option>
                                                )}
                                            </Select>
                                        </FormField>

                                        <Button type="submit" loading={isLoading}>Update</Button>
                                    </form>
                                </CardBody>
                            </FormCard>

                            <Card padded={false}>
                                <CardTitleBar title="Cancel request"/>
                                <CardBody>
                                    <Button
                                        variant="danger"
                                        loading={isLoading}
                                        onClick={() => setShowCancelModal(true)}
                                    >
                                        Cancel request
                                    </Button>
                                </CardBody>
                            </Card>
                        </div>
                        }


                    </div>
                </Columns>
                }

                {tab === "sender" &&
                <Card style={{maxWidth: 480}}>
                    <KV style={{marginBottom: 0}}>
                        <tbody>
                        <tr>
                            <td>Name</td>
                            <td><Link to={"/client/" + item.user_id}>{item.user_details.name}</Link></td>
                        </tr>
                        <tr>
                            <td>Phone</td>
                            <td>{item.user_details.phone}</td>
                        </tr>
                        <tr>
                            <td>Email</td>
                            <td>{item.user_details.email}</td>
                        </tr>
                        </tbody>
                    </KV>
                </Card>
                }

                {tab === "dropoffs" &&
                <TableCard padded={false}>
                    <Grid>
                        <thead>
                        <tr>
                            <th>Address</th>
                            <th>Phone Number</th>
                            <th>Notes</th>
                            <th>Status</th>
                            <th>Receiving Code</th>
                            <th>Client Sign.</th>
                            <th>Rider Sign.</th>
                        </tr>
                        </thead>
                        <tbody>
                        {item.drop_offs.map((i, k) => <tr key={k}>
                            <td>{i.address}</td>
                            <td>{i.phone}</td>
                            <td>{i.notes}</td>
                            <td>{i.status}</td>
                            <td>{i.receiving_code}</td>
                            <td>
                                {i.client_signature === "" ? "-" : <img
                                    src={Endpoints.SERVER_HOST + Endpoints.FILE_URL + i.client_signature}
                                    style={{height: 90}}/>}
                            </td>
                            <td>
                                {i.rider_signature === "" ? "-" : <img
                                    src={Endpoints.SERVER_HOST + Endpoints.FILE_URL + i.rider_signature}
                                    style={{height: 90}}/>}
                            </td>
                        </tr>)}
                        </tbody>
                    </Grid>
                </TableCard>
                }

                {tab === "riders" &&
                <TableCard padded={false}>
                    <Grid>
                        <thead>
                        <tr>
                            <th>Rider</th>
                            <th>Role</th>
                            <th>Code</th>
                            <th>Status</th>
                            <th>Receiving Details</th>
                            <th>Handing Over Details</th>
                        </tr>
                        </thead>
                        {item.involved_riders &&
                        <tbody>
                        {item.involved_riders.map((i, k) => <tr key={k}>
                                <td><Link to={"/riders/" + i.rider_id}>{i.rider_details.name}</Link></td>
                                <td>{i.role}</td>
                                <td>{i.code}</td>
                                <td>{i.status}</td>
                                <td>
                                    <b>Time</b> : {i.accepting_time_string}<br/>
                                    <b>Location</b> : {i.accepting_location}<br/>
                                    <b>LatLng</b> : {i.accepting_lat}, {i.accepting_lng}<br/><br/>
                                    {i.accepting_signature === "" ? "-" : <img
                                        src={Endpoints.SERVER_HOST + Endpoints.FILE_URL + i.accepting_signature}
                                        style={{height: 90}}/>}
                                </td>
                                <td>
                                    {i.status !== "PENDING" &&
                                    <div>
                                        <b>Time</b> : {i.handing_time_string}<br/>
                                        <b>Location</b> : {i.handing_location}<br/>
                                        <b>LatLng</b> : {i.handing_lat}, {i.handing_lng}<br/><br/>
                                        {i.handing_signature === "" ? "-" : <img
                                            src={Endpoints.SERVER_HOST + Endpoints.FILE_URL + i.handing_signature}
                                            style={{height: 90}}/>}
                                    </div>
                                    }
                                </td>
                            </tr>
                        )}
                        </tbody>
                        }
                    </Grid>
                </TableCard>
                }

                {tab === "tracking" &&
                <Card>
                    {item.tracking &&
                    <div>
                        {item.tracking.map((i, k) =>
                            <TimelineItem key={k}>
                                <span className="icon">
                                    <i className="fa fa-truck fa-2x"></i>
                                </span>
                                <div>
                                    <p className="text">{i.text}</p>
                                    <p className="time">{i.date_added_string}</p>
                                </div>
                            </TimelineItem>
                        )}
                    </div>
                    }
                </Card>
                }
            </>
            }
            {showCancelModal &&
            <ReasonCaptureModal
                title="Cancel request"
                onCancel={() => setShowCancelModal(false)}
                onConfirm={reason => { cancelRequest(reason); setShowCancelModal(false); }}
            />
            }
        </PageLayout>
    )
}
;

export default RequestDetails
